function textRemove() {
    this.textContent = "";
}
function textConstant(value) {
    return function () {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function () {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
export default function (value) {
    return arguments.length
        ? this.each(value == null
            ? textRemove : (typeof value === "function"
            ? textFunction
            : textConstant)(value))
        : this.node().textContent;
}
